import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useMemo } from 'react';
import type { ReactNode } from 'react';
import type { DefaultTheme } from 'styled-components';
import { theme, nightModeColors, lightModeColors } from 'theme/theme';
import { useAppSelector } from 'store/hooks';
import { selectUserConfigIsNightMode } from 'app/userPreferences/selectors';

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const isNightMode = useAppSelector(selectUserConfigIsNightMode);
  const isDark = isNightMode ?? false;

  const styledTheme: DefaultTheme = useMemo(
    () => ({
      ...theme,
      colors: isDark ? nightModeColors : lightModeColors,
    }),
    [isDark],
  );

  return (
    <StyledThemeProvider theme={styledTheme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
